import { defineStore } from 'pinia'
import { computed, ref } from 'vue'

export interface StageMarketingConfig {
  promoEnabled?: boolean
  promoBadge?: string
  promoDescription?: string
  promoCta?: string
}

const DEFAULT_PROMO_BADGE = '7 天体验 + 首月特惠'
const DEFAULT_PROMO_DESCRIPTION = '更长记忆窗口、专属语音情绪模式、高峰优先响应。先体验再决定长期订阅。'
const DEFAULT_PROMO_CTA = '立即体验 Pro'

export const useCommerceStore = defineStore('commerce', () => {
  const promoEnabled = ref(true)
  const promoBadge = ref(DEFAULT_PROMO_BADGE)
  const promoDescription = ref(DEFAULT_PROMO_DESCRIPTION)
  const promoCta = ref(DEFAULT_PROMO_CTA)

  const hasPromo = computed(() => promoEnabled.value)

  function setMarketingConfig(config?: StageMarketingConfig) {
    promoEnabled.value = config?.promoEnabled ?? true
    promoBadge.value = config?.promoBadge?.trim() || DEFAULT_PROMO_BADGE
    promoDescription.value = config?.promoDescription?.trim() || DEFAULT_PROMO_DESCRIPTION
    promoCta.value = config?.promoCta?.trim() || DEFAULT_PROMO_CTA
  }

  return {
    promoEnabled,
    promoBadge,
    promoDescription,
    promoCta,
    hasPromo,
    setMarketingConfig,
  }
})
